<template>
    <span v-if="text != null && maxLengthText > 0 && (text != null && text != '' && text.length > maxLengthText)" class="position-static" boundary="viewport">
        <span :id="'popover-target-' + id">
            {{ text != null && text != "" ? text.slice(0, maxLengthText) + (text.length > maxLengthText ? "..." : "" ) : "" }}
        </span>
        <b-popover :target="'popover-target-' + id" triggers="hover focus" placement="bottom" boundary="viewport" class="boundary-datepicker">
            {{ text != null && text != '' ? text : ''}}
        </b-popover>
    </span>
    <span v-else>
        <span :id="'popover-target-' + id" v-if="text != null && text != '' && text != undefined">
            {{ text }}
        </span>
        <span class="text-transparent" v-else>
            -
        </span>
        <b-popover v-if="showPopover" :target="'popover-target-' + id" triggers="hover focus" placement="bottom" boundary="viewport" class="boundary-datepicker">
            {{ text != null && text != '' ? text : ''}}
        </b-popover>
    </span>
</template>
<style scoped>
.text-transparent {
    color: transparent;
}
</style>
<script>

export default {
    props: {
        id : {
            default: 'long-text',
            type: String,
        },
        text : {
            default: '',
            type: String,
        },
        maxLength : {
            default: 30,
            type: Number,
        },
        mdMaxLength : {
            type: Number,
        },
        showPopover : {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            windowWidth: 0,
            maxLengthText: 0,
        };
    },
    mounted() {
        this.onResize();
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    methods : {
        onResize() {
            this.maxLengthText = this.maxLength;
            this.windowWidth = window.innerWidth;
            if (this.windowWidth > 768) {
                if (this.mdMaxLength != NaN && this.mdMaxLength != null && this.mdMaxLength != undefined)
                    this.maxLengthText = this.mdMaxLength;
            }
        }
    }
    
}
</script>